import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Target, Users, Shield, Search, Map, Brain } from 'lucide-react';
const values = [{
  icon: <Target className="w-8 h-8 text-ice-500" data-id="element-146" data-mp="12pltxu6y9sf2" />,
  title: 'Development First',
  description: 'We prioritize long-term growth over short-term wins. Teaching players to be the best teammate and represent their community to the highest standard.'
}, {
  icon: <Users className="w-8 h-8 text-ice-500" data-id="element-147" data-mp="1hft3tliw6345" />,
  title: 'Family Centered Advisory',
  description: 'Your family is part of our team. We ensure everyone is educated, informed, and comfortable with every decision made along the journey.'
}, {
  icon: <Shield className="w-8 h-8 text-ice-500" data-id="element-148" data-mp="1vg3twmcdndo9" />,
  title: 'Truth Over Hype',
  description: "Honest evaluations and real expectations. We don't waste players' or families' time with false promises."
}, {
  icon: <Search className="w-8 h-8 text-ice-500" data-id="element-149" data-mp="13e0s6tu28hx" />,
  title: 'Player ID & Evaluation',
  description: "Detailed camps, comprehensive assessments, and actionable recommendations to identify exactly what's needed for the next level."
}, {
  icon: <Map className="w-8 h-8 text-ice-500" data-id="element-150" data-mp="3cj9hx7sl7xsm" />,
  title: 'Pathway Mapping',
  description: 'We build Plan A, B, and C for every player, assisting with recruiting, team analysis, and finding the perfect league fit.'
}, {
  icon: <Brain className="w-8 h-8 text-ice-500" data-id="element-151" data-mp="45kh085ip9ro" />,
  title: 'Mental Resilience',
  description: "Support through trades, cuts, and injuries. We've both been there and provide the guidance needed to transition and overcome adversity."
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export const MissionSection = () => {
  return <section id="mission" className="py-24 bg-navy-800 relative" data-id="element-152" data-mp="2cdfhygbfjr12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-153" data-mp="2hc8zcjtu826i">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-154" data-mp="2h9moaa7qn4jj">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="text-4xl md:text-5xl font-bold text-white mb-6 uppercase tracking-tight" data-id="element-155" data-mp="23bprpdtaay4v">
            Built <span className="text-ice-500" data-id="element-156" data-mp="1knktsmzb67dz">Different</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          delay: 0.1
        }} className="text-lg text-slate-300" data-id="element-157" data-mp="1oo4qjpfyz8zl">
            Our core values dictate everything we do. We put a huge emphasis on
            teaching players to not only be the best player they can be, but the
            best person off the ice.
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-158" data-mp="1ezpo63r066hg">
          {values.map((value, index) => <motion.div key={index} variants={itemVariants} className="bg-navy-900 border border-navy-700 p-8 rounded-sm hover:border-ice-500/50 transition-colors group" data-id="element-159" data-mp="1jq64bvm7k67i" data-mpi={index}>
              <div className="mb-6 p-3 bg-navy-800 inline-block rounded-sm group-hover:bg-ice-500/10 transition-colors" data-id="element-160" data-mp="1tq6pzo7juyev">
                {value.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-161" data-mp="3s5nqd6y4ef3o">
                {value.title}
              </h3>
              <p className="text-slate-400 leading-relaxed" data-id="element-162" data-mp="t2rckw2msjm">
                {value.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
};